import React from 'react'
import Hero from '../Hero'
import Feature2 from '../Feature2'
import Cta from '../Cta'
import Pricing from './Pricing'
import FormPage from './Forms/FormPage'
import Testimonials from './Testimonials'


const Home = () => {
    return (
        <div>
            <Hero />
            <Feature2 />
            <Cta />
            <Pricing />
            <FormPage />
            <Testimonials />
            
        </div>
    )
}

export default Home
